define([
	'internal_util/Util',
	'internal_util/Logger',
	'model/ActivationType',
	'model/Error',
	'model/ErrorType',
	'service/Core',
	'service/EventListenerRegistry',
	'service/UIStateManager',
	'interceptor/StateChangeInterceptor',
	'amdi18n-loader?!service/interceptor/nls/StateChangeInterceptor_strings',
	'amdi18n-loader?!service/interceptor/nls/IdentityCreationInterceptor_strings'

], function (
	Util,
	Logger,
	ActivationType,
	Error,
	ErrorType,
	Core,
	EventListenerRegistry,
	UIStateManager,
	StateChangeInterceptor,
	GenericStrings,
	Strings
) {
	'use strict';

	/**
	 * RecoveryStrategyInterceptor class
	 */
	function IdentityCreationInterceptor(core, uiStateManager) {
		var _core,
                    _uiStateManager,
                    _skipNext = false;

		if (core instanceof Core) {
			_core = core;
		} else {
			throw new Error('no valid core found');
		}

		if (uiStateManager instanceof UIStateManager) {
			_uiStateManager = uiStateManager;
		} else {
			throw new Error('no valid uiStateManager found');
		}

		StateChangeInterceptor.call(this);


		// private methods

		function log(method, message, data) {
			Logger.log('IdentityCreationInterceptor', method, message, data);
		}

		function callLog(method, message, data, event, callbacks) {
			log(method, message, data);
			EventListenerRegistry.callListeners(event, data, function () {
				Util.callCallbacks(callbacks, data);
			});
		}



		// public methods

		this.intercept = function (previous, next) {
			var _name = 'intercept',
                            _cloudIdentitiesManager = _core.cloudIdentitiesManager();
                        
			if (_skipNext) {
				_skipNext = false;
				return false;
			}
                        
                        

			if (next['state'].id() === 'identity_creation' && _cloudIdentitiesManager.identities().length > 0) {
                            callLog(_name, GenericStrings.state_interception_started,
                                { previous : previous['state'], next :  next['state'] }, 'UI_STATE_INTERCEPTION_STARTED', function () {
                                        _uiStateManager.change('error',
                                                new Error(ErrorType.NON_RECOVERABLE, Strings.identity_creation_not_allowed));
                                                
                                        callLog(_name, GenericStrings.state_interception_finished,
                                            { previous : previous['state'], next : next['state'] }, 'UI_STATE_INTERCEPTION_FINISHED');
                                });
                            return true;
                        }

			return false;
		};
	}

	IdentityCreationInterceptor.prototype = Object.create(StateChangeInterceptor.prototype);

	return IdentityCreationInterceptor;
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/service/interceptor/IdentityCreationInterceptor.js
// module id = 368
// module chunks = 4